module.exports = __webpack_public_path__ + "img/img-icon-chanpin4-tuya.de7aee67.webp";